import {useRef,useEffect} from "react";



function StarryBackground() {
    const canvasRef = useRef(null);
  
    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
  
      // ★星の設定
      const stars = [];
      const numStars = 300;
      const starSpeed = 4; // 星の移動速度
  
      for (let i = 0; i < numStars; i++) {
        stars.push({
          x: (Math.random() - 0.5) * window.innerWidth * 2, // 中心を基準に配置
          y: (Math.random() - 0.5) * window.innerHeight * 2,
          z: Math.random() * window.innerWidth,
        });
      }
  
      // 数式（または物理の式）の設定
      const formulasPool = [
        "E = mc²",
        "F = ma",
        "a² + b² = c²",
        "∇·E = ρ/ε₀",
        "λν = c",
        "PV = nRT",
        "V = IR",
        "e^(iπ) + 1 = 0"
      ];
      const formulas = [];
      const numFormulas = 10; // 表示する数式の数
      const formulaSpeed = 2; // 数式の移動速度（星よりゆっくり）
      const baseFontSize = 20; // 数式の基本フォントサイズ
  
      for (let i = 0; i < numFormulas; i++) {
        formulas.push({
          text: formulasPool[Math.floor(Math.random() * formulasPool.length)],
          x: (Math.random() - 0.5) * window.innerWidth * 2,
          y: (Math.random() - 0.5) * window.innerHeight * 2,
          z: Math.random() * window.innerWidth,
        });
      }
  
      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
  
        // 星の描画
        stars.forEach((star) => {
          star.z -= starSpeed; // 星を手前に移動
  
          if (star.z < 1) {
            // 画面を通過したら再配置
            star.x = (Math.random() - 0.5) * window.innerWidth * 2;
            star.y = (Math.random() - 0.5) * window.innerHeight * 2;
            star.z = window.innerWidth;
          }
  
          const scale = 300 / star.z; // 近づくほど大きく
          const sx = star.x * scale + canvas.width / 2;
          const sy = star.y * scale + canvas.height / 2;
          const starSize = Math.max(scale * 2, 1);
  
          ctx.beginPath();
          ctx.arc(sx, sy, starSize, 0, Math.PI * 2);
          ctx.fillStyle = "white";
          ctx.fill();
          ctx.closePath();
        });
  
        // 数式の描画
        formulas.forEach((formula) => {
          formula.z -= formulaSpeed; // 数式も手前に移動
  
          if (formula.z < 1) {
            // 数式が画面を通過したら再配置＆ランダムな数式を選ぶ
            formula.x = (Math.random() - 0.5) * window.innerWidth * 2;
            formula.y = (Math.random() - 0.5) * window.innerHeight * 2;
            formula.z = window.innerWidth;
            formula.text = formulasPool[Math.floor(Math.random() * formulasPool.length)];
          }
  
          const scale = 300 / formula.z; // パースペクティブ効果
          const sx = formula.x * scale + canvas.width / 2;
          const sy = formula.y * scale + canvas.height / 2;
          const fontSize = Math.max(baseFontSize * scale, 12); // フォントサイズの下限を設定
  
          ctx.save();
          ctx.translate(sx, sy);
          // 必要に応じて少し回転させたり、透明度を調整することも可能
          ctx.font = `${fontSize}px sans-serif`;
          ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(formula.text, 0, 0);
          ctx.restore();
        });
  
        requestAnimationFrame(animate);
      }
  
      // キャンバスの初期サイズを設定
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
  
      animate();
    }, []);
  
    return (
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          background: "black",
        }}
      />
    );
  }
  

export default StarryBackground;